import {Component, Input, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {HttpResponse, HttpErrorResponse, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';
import {Setting, ISetting} from '../../shared/model/setting.model';
import {SettingService} from './setting.service';
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {Organization} from "../../shared/model/organization.model";
import {EventService} from "../../singelton/event.service";
import {SHOW_STORE, SHOW_TICKET} from "../../app.constants";
import {AccountService} from "../../singelton/account.service";
import {Employee, IEmployee} from "../../shared/model/employee.model";
import {EmployeeService} from "../../core/employee/employee.service";
import {FeatureFlagsService} from "../../singelton/feature-flags.service";


@Component({
  selector: 'app-setting-update',
  templateUrl: './setting-update.component.html'
})
export class SettingUpdateComponent implements OnInit {
  setting: ISetting = new Setting();
  settingGeneral: ISetting = new Setting();
  isSaving: boolean;
  @Input() settingEdit;
  settings: ISetting[];
  show_ticket: any = SHOW_TICKET;
  show_store: any = SHOW_STORE;
  userId: any;
  employee: IEmployee = new Employee();

  constructor(protected settingService: SettingService, protected activatedRoute: ActivatedRoute, public activeModal: NgbActiveModal,
              protected eventService: EventService, public accountService: AccountService, protected employeeService: EmployeeService,
              private featureFlags: FeatureFlagsService) {
  }

  ngOnInit() {
    this.isSaving = false;

    this.accountService.identity().then(d => {

      this.userId = d.id;
      this.employeeService.findByUserId(this.userId).subscribe(
        (res: HttpResponse<IEmployee>) => {
          this.employee = res.body;
          this.loadSettingsGeneral();
          this.loadSettings();

        },
        (res: HttpErrorResponse) => this.onError(res.message)
      );
    });
    // this.loadSettings();
// alert(' in init ==' + this.settingEdit);
//     if (this.settingEdit) {
//       this.settingService.find(this.settingEdit).subscribe(
//         (res: HttpResponse<ISetting>) => {
//           this.setting = res.body;
//           // alert(this.setting);
//         },
//         (res: HttpErrorResponse) => this.onError(res.message)
//       );
//     }

    // this.activatedRoute.data.subscribe(({setting}) => {
    //   this.setting = setting;
    // });
  }


  loadSettings() {
    this.settingService
    // .query()
      .findByEmployee(this.employee.id)
      .subscribe(
        (res: HttpResponse<ISetting>) => this.paginateSetting(res.body, res.headers),
        (res: HttpErrorResponse) => this.onError(res.message)
      );
  }

  loadSettingsGeneral() {
    this.settingService
    // .query()
      .findGeneral()
      .subscribe(
        (res: HttpResponse<ISetting>) => this.paginateSettingGeneral(res.body, res.headers),
        (res: HttpErrorResponse) => this.onError(res.message)
      );
  }


  protected paginateSetting(data: ISetting, headers: HttpHeaders) {
    this.setting = data;
    // this.settings = data;
    // if(this.settings && this.settings.length > 0 ){
    //   this.setting = this.settings[0];
    // }
  }

  protected paginateSettingGeneral(data: ISetting, headers: HttpHeaders) {
    this.settingGeneral = this.featureFlags.ensureDefaultsOn(data || new Setting());
  }


  protected onError(errorMessage: string) {
    // this.jhiAlertService.error(errorMessage, null, null);
  }

  previousState() {
    window.history.back();
  }

  save() {
    this.isSaving = true;
    this.setting.employee_str = this.employee.id + '';
    this.setting.employee = this.employee;

    // this.setting.organization = new Organization(1);
    this.settingGeneral.type = 'general';
    if (this.settingGeneral.id !== undefined) {
      this.subscribeToSaveResponseGeneral(this.settingService.update(this.settingGeneral));
    } else {
      this.subscribeToSaveResponseGeneral(this.settingService.create(this.settingGeneral));
    }
    if (this.setting.id !== undefined) {
      this.subscribeToSaveResponse(this.settingService.update(this.setting));
    } else {
      this.subscribeToSaveResponse(this.settingService.create(this.setting));
    }
  }

  protected subscribeToSaveResponseGeneral(result: Observable<HttpResponse<ISetting>>) {
    result.subscribe((res: HttpResponse<ISetting>) => this.onSaveSuccessGeneral(), (res: HttpErrorResponse) => this.onSaveError());
  }

  protected subscribeToSaveResponse(result: Observable<HttpResponse<ISetting>>) {
    result.subscribe((res: HttpResponse<ISetting>) => this.onSaveSuccess(), (res: HttpErrorResponse) => this.onSaveError());
  }

  protected onSaveSuccess() {
    this.isSaving = false;
    this.eventService.onResponseSetting('test message 22');

    this.activeModal.dismiss('cancel');

    // this.previousState();
  }

  protected onSaveSuccessGeneral() {
    this.isSaving = false;
    this.featureFlags.apply(this.settingGeneral);
    this.featureFlags.load();
    this.eventService.onResponseSetting('test message 22');

    this.activeModal.dismiss('cancel');

    // this.previousState();
  }

  protected onSaveError() {
    this.isSaving = false;
  }


  clear() {
    this.activeModal.dismiss('cancel');
  }


}
